import React, { Component } from 'react';
import PageTitle from './PageTitle';
import { browserHistory } from 'react-router';
import Input from './Input';
import PubSub from 'pubsub-js';
import TratadorErros from './TratadorErros';
import $ from 'jquery';

export default class Contact extends Component {

    constructor(props) {
        super(props);
        this.state = {
            nome: '',
            email: '',
            telefone: '',
            mensagem: ''
        };
        this.handleChange = this.handleChange.bind(this);
        this.sendContact = this.sendContact.bind(this);
    }

    handleChange(e) {
        var change = {}
        change[e.target.name] = e.target.value
        this.setState(change)
    }

    sendContact(event) {
        event.preventDefault();

        $.ajax({
            url: 'http://api.fcsistema.com.br/api-website-fc/contact/save',
            contentType: 'application/json',
            dataType: 'json',
            type: 'post',
            data: JSON.stringify({
                nome: this.state.nome,
                email: this.state.email,
                telefone: this.state.telefone,
                mensagem: this.state.mensagem
            }),
            success: function (response) {
                alert('Obrigado por entrar em contato, retornaremos em breve!');
                browserHistory.push('/');
            },
            error: function (response) {
                if (response.status === 400) {
                    console.log(response);
                    new TratadorErros().publicaErros(response.responseJSON);
                }
            },
            beforeSend: function () {
                PubSub.publish("limpa-erros", {});
            }
        });
    }

    render() {
        const Captcha = require('react-captcha');

        return (
            <div>
                <PageTitle title="Contato" last="Home" lastLink="/" />
                <section className="section-padding">

                    <div className="container">

                        <div className="text-center mb-80">
                            <h2 className="section-title text-uppercase">Contato</h2>
                            <p className="section-sub">Deixe-nos uma mensagem</p>
                        </div>

                        <div className="row">
                            <div className="col-md-8">
                                <form name="contact-form" id="contactForm" onSubmit={this.sendContact} method="POST">

                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="input-field">
                                                <Input type="text" name="nome" className="validate" label="Nome" autoComplete="name"
                                                    id="nome" value={this.state.nome} onChange={this.handleChange.bind(this)} />
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="input-field">
                                                <Input id="email" type="email" name="email" className="validate" label="Email" autoComplete="email"
                                                    value={this.state.email} onChange={this.handleChange.bind(this)} />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="input-field">
                                                <Input id="telefone" type="tel" name="telefone" className="validate" label="Telefone" autoComplete="tel-national"
                                                    value={this.state.telefone} onChange={this.handleChange.bind(this)} />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="input-field">
                                        <textarea name="mensagem" id="mensagem" className="materialize-textarea" label="Mensagem"
                                            value={this.state.mensagem} onChange={this.handleChange.bind(this)}></textarea>
                                        <label htmlFor="message">Mensagem</label>
                                    </div>

                                    <Captcha
                                        sitekey='6LftID4UAAAAAOkYFe1Z34npeeBEQmd4Cidzw143'
                                        lang='pt-BR'
                                        theme='light'
                                        type='image'
                                        callback={(value) => console.log(value)} />


                                    <button type="submit" name="submit" className="waves-effect waves-light btn btn-blue submit-button mt-30">Enviar Mensagem</button>
                                </form>
                            </div>

                            <div className="col-md-4 contact-info">

                                <address>

                                    <i className="material-icons brand-color"></i>
                                    <div className="phone">
                                        <p>(16) 99242-6932<br />
                                            (16) 99113-6449</p>
                                    </div>

                                    <i className="material-icons brand-color"></i>
                                    <div className="mail">
                                        <p><a href="mailto:contato@fcsistema.com.br">contato@fcsistema.com.br</a><br />
                                            <a href="http://fcsistema.com.br">www.fcsistema.com.br</a></p>
                                    </div>
                                </address>

                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Contact.js